'use client';

import React, { useEffect, useState } from "react";
import "./MatchLatest.scss";
import NoData from "@/components/client/NoData";
import CollapsiblePanel from "@/components/client/CollapsiblePanel";
import ICON_ARROW_UP_LEAGUES from "@/public/arrow_up_white_leagues.svg";
import ICON_ARROW_DOWN_LEAGUES from "@/public/arrow_down_white_leagues.svg";
import DataMatchLatest from "@/components/client/DataMatchLatest";
import { MatchLabel } from "@/components/server/Match";
import MatchServices from "@/services/MatchServices";
import LoadingInner from "@/app/loadingInner";

const IMAGE_ARROW_DOWN_LEAGUES = ICON_ARROW_DOWN_LEAGUES.src;
const IMAGE_ARROW_UP_LEAGUES = ICON_ARROW_UP_LEAGUES.src;

export default function MatchLatest({ matchId }) {
  const [match, setMatch] = useState(null);
  const [matchLatest, setMatchLatest] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMatchData = async () => {
      try {
        const matchData = await MatchServices.getMatchById(matchId);
        setMatch(matchData);

        if (matchData) {
          const { homeId, awayId } = matchData;
          const matchLatestData = await MatchServices.getMatchLatest(
            matchId,
            homeId,
            awayId
          );
          setMatchLatest(matchLatestData);
        }
      } catch (error) {
        console.error("Error fetching match data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMatchData();
  }, [matchId]);

  if (loading) {
    return (
      <>
        <MatchLabel label={"Thành tích gần đây"} />
        <LoadingInner />
      </>
    );
  }

  if (!match || match.length === 0) {
    return (
      <>
        <MatchLabel label={"Thành tích gần đây"} />
        <NoData />
      </>
    );
  }

  if (
    matchLatest?.homeMatches?.length === 0 &&
    matchLatest?.awayMatches?.length === 0
  ) {
    return (
      <CollapsiblePanel
        title="3 trận sắp tới"
        initOpen={true}
        iconUp={IMAGE_ARROW_UP_LEAGUES}
        iconDown={IMAGE_ARROW_DOWN_LEAGUES}
      >
        {match.status === "-1" ? (
          <NoData message="Không có dữ liệu" />
        ) : (
          <NoData message="Đang cập nhật..." />
        )}
      </CollapsiblePanel>
    );
  }

  return (
    <CollapsiblePanel
      title="3 trận sắp tới"
      initOpen={true}
      iconUp={IMAGE_ARROW_UP_LEAGUES}
      iconDown={IMAGE_ARROW_DOWN_LEAGUES}
    >
      <DataMatchLatest matchLatest={matchLatest} match={match} />
    </CollapsiblePanel>
  );
}
